import React, { useState, useEffect } from "react";
import axios from "axios";
import "./index.css";
import { production } from "./constants";

const TrainBot = (props) => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(() => {
    return localStorage.getItem("sessionId") || null;
  });

  useEffect(() => {
    const defaultMessage = {
      role: "assistant",
      content: "Heyyy! Em là trợ lý ảo của anh Silver ạ. Anh Silver đang bận nên em sẽ ở đây trực, tin nhắn sẽ được gửi tới anh ý định kỳ hàng ngày nhé ạ!"
    };
    setMessages([defaultMessage]);
  }, []);
 
  const sendMessage = async () => {
    if (!input.trim()) return;
    setInput("");
    const tempInput = input;
    const userMessage = { role: "user", content: tempInput };
    setMessages((prevMessages) => [...prevMessages, userMessage]);

    try {
      setLoading(true);
      const response = await axios.post(production+"/chat", {
        message: tempInput,
        sessionId, // Gửi sessionId hiện tại
      });

      // Lưu sessionId nếu server trả về (chỉ cần cho lần đầu)
      if (response.data.sessionId && !sessionId) {
        setSessionId(response.data.sessionId);
        localStorage.setItem("sessionId", response.data.sessionId); // Lưu vào localStorage
      }

      const botReply = { role: "assistant", content: response.data.reply };
      setMessages((prevMessages) => [...prevMessages, botReply]);
      setLoading(false);
    } catch (error) {
      console.error("Error sending message:", error);
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
        if(input === 'exit') {
            props.changeScreen('chatbot');
            setInput('');
        } else {
            sendMessage();
        }
    }
  };

  return (
    [<div className="chatbot-container">
      <h1 className="chatbot-title" style={{color: 'red'}}>{loading ? 'Please wait...' : 'Silva - Training Bot'}</h1>
      <div className="chatbox">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`message ${
              msg.role === "user" ? "user-message" : "assistant-message"
            }`}
          >
            <div className="message-content">
              <strong>{msg.role === "user" ? "You" : "Silva - Lovable Bot"}:</strong>{" "}
              {msg.content}
            </div>
          </div>
        ))}
      </div>
      <div className="input-container">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Type your message..."
          className="input-box"
        />
        <button onClick={sendMessage} className="send-button">
          Send
        </button>
      </div>
      
    </div>,
    <div style={{width: '100%', textAlign: 'center', padding: '16px 0', fontFamily: 'Arial, sans-serif', color: 'grey'}}>Made with love by Silver</div>]
  );
};

export default TrainBot;